import React, { useContext } from 'react';
import { Page } from '../types';
import { PageContext } from '../PageContext';
import BackButton from '../components/BackButton';

interface CategoryCardProps {
    title: string;
    imageUrl: string;
    onClick: () => void;
}

const CategoryCard: React.FC<CategoryCardProps> = ({ title, imageUrl, onClick }) => (
    <div 
        className="rounded-3xl p-2 cursor-pointer transition transform hover:-translate-y-1"
        style={{ backgroundColor: 'var(--primary-dark-purple)' }}
        onClick={onClick}
    >
        <div className="border-4 border-white rounded-2xl p-2 relative">
             <img src={imageUrl} className="w-full h-[120px] object-cover rounded-xl" alt={title} />
             <div className="absolute bottom-4 left-4 right-4">
                <h2 className="text-white font-extrabold text-2xl text-center tracking-wide" style={{ textShadow: '2px 2px 4px rgba(0,0,0,0.7)' }}>{title.toUpperCase()}</h2>
             </div>
        </div>
    </div>
);

const FeaturedBrandsPage: React.FC = () => {
    const pageContext = useContext(PageContext);

    const handleCategoryClick = (category: string) => {
        pageContext?.switchPage(Page.FilteredFeed, category, { category });
    };

    const brandCategories = [
        { title: "Tech & Electronics", imageUrl: "https://images.unsplash.com/photo-1498049794561-7780e7231661?q=80&w=2000&auto=format&fit=crop" },
        { title: "Toys & Games", imageUrl: "https://images.unsplash.com/photo-1566576912321-d58ddd7a6088?q=80&w=2000&auto=format&fit=crop" },
        { title: "Clothes & Apparel", imageUrl: "https://images.unsplash.com/photo-1523381210434-271e8be1f52b?q=80&w=2000&auto=format&fit=crop" },
        { title: "Footwear", imageUrl: "https://images.unsplash.com/photo-1542291026-7eec264c27ff?q=80&w=2000&auto=format&fit=crop" },
    ];

    return (
        <div className="space-y-4">
            <BackButton text="Back to Categories" />
            {brandCategories.map(item => (
                <CategoryCard
                    key={item.title}
                    title={item.title}
                    imageUrl={item.imageUrl}
                    onClick={() => handleCategoryClick(item.title)}
                />
            ))}
        </div>
    );
};

export default FeaturedBrandsPage;
